<app-section
  titleSection="Cadastre"
  [isLargeTitle]="true"
  [isActivated]="cadastre.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"

>
  <div read-mode class="px-3">
    <app-cadastre-read-mode
      [reportId]="reportId"
      [cadastre]="cadastre"
      [cityLabel]="cityLabel"
      [cityCode]="cityCode"
    >
    </app-cadastre-read-mode>
  </div>

  <div edit-mode>
    <ng-container>
      <app-cadastre-edit-mode
        [resetKey]="editModeKey"
        [cadastre]="cadastre"
        [cityLabel]="cityLabel"
        [cityCode]="cityCode"
        (cadastreChanged)="onCadastreChanged($event)"
      ></app-cadastre-edit-mode>
    </ng-container>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
